"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-sixteen/section/teamSection.tsx */

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type TeamSectionSlidesItem = {
    key: Key | null | undefined;
    /** Detected variants: "1s" | "1.5s" | "2s" | "2.5s" | "3s" */
    dataWowDuration: string;
    /** Detected variants: "/Templates/Doccure/img/team/team-img-1.png" | "/Templates/Doccure/img/team/team-img-2.png" | "/Templates/Doccure/img/team/team-img-3.png" | "/Templates/Doccure/img/team/team-img-4.png" | "/Templates/Doccure/img/team/team-img-5.png" */
    src: string;
    /** Detected variants: "10+ Years Practicing" | "08+ Years Practicing" | "07+ Years Practicing" | "12+ Years Practicing" | "14+ Years Practicing" */
    span0Text: ReactNode;
    /** Detected variants: "Dr. Anita Desai" | "Dr. Sarah Mitchell" | "Dr. Emily Rodriguez" | "Dr. James Tran" | "Dr. Jamie Aurora" */
    link0Text: ReactNode;
    /** Detected variants: "Registered Dietitian" | "Lead Clinical Dietitian" | "Nutrition Scientist" | "Senior Nutrition Consultant" | "Lead Surgeon" */
    p0Text: ReactNode;
    /** Detected variants: "slide-item" */
    className?: string;
    /** Detected variants: "team-item-sixteen wow fadeInUp" */
    div0ClassName?: string;
    /** Detected variants: "team-overlay" */
    div0ClassName2?: string;
    /** Detected variants: "team" */
    alt?: string;
    /** Detected variants: "img-fluid img-one" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "experience" */
    span0ClassName?: string;
    /** Detected variants: "team-content" */
    div1ClassName?: string;
    /** Detected variants: "team-info" */
    div0ClassName3?: string;
    /** Detected variants: "team-name" */
    h30ClassName?: string;
    /** Detected variants: "#" */
    href?: string;
    /** Detected variants: "team-special" */
    div1ClassName2?: string;
    /** Detected variants: "Specialties:" */
    h40Text?: ReactNode;
    /** Detected variants: "specialties-title" */
    h40ClassName?: string;
    socialIconItems?: TeamSectionIconsItem[];
    specialtiesListItems?: TeamSectionBadgesItem[];
};

type TeamSectionIconsItem = {
    key: Key | null | undefined;
    /** Detected variants: "Facebook" | "Twitter" | "Instagram" | "LinkedIn" */
    ariaLabel: string;
    /** Detected variants: "fab fa-facebook-f" | "fab fa-twitter" | "fab fa-instagram" | "fab fa-linkedin-in" */
    className: string;
    /** Detected variants: "icon" */
    linkClassName?: string;
    /** Detected variants: "#" */
    href?: string;
};

type TeamSectionBadgesItem = {
    key: Key | null | undefined;
    /** Detected variants: "Diabetes Care" | "Cardiovascular Health" | "Sports Nutrition" | "Metabolic Health" | "Gut Microbiome" | "Chronic Prevention" | "Pediatric Nutrition" | "Food Sensitivities" | "Weight management" | "Sports nutrition" */
    linkText: ReactNode;
    /** Detected variants: "badge" */
    className?: string;
    /** Detected variants: "#" */
    href?: string;
};
export type HomeSixteenTeamSectionGeneratedProps = {
    linkLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TeamSectionIconsItem) => Partial<ComponentProps<typeof SmartLink>>);
    teamSectionBadgesLinkLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TeamSectionBadgesItem) => Partial<ComponentProps<typeof SmartLink>>);
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "Meet Our Team" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "Certified experts dedicated to your health" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "transformation journey" */
    sectionDiv0Div0H20Span0SpanText?: ReactNode;
    /** Default: "teams" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/teams-img-1.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    sectionSwiper0SwiperProps?: Partial<ComponentProps<typeof Swiper>>;
    swiperSlideSwiperSlideProps?: Partial<ComponentProps<typeof SwiperSlide>> | ((item: TeamSectionSlidesItem) => Partial<ComponentProps<typeof SwiperSlide>>);
    swiperSlideDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TeamSectionSlidesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    swiperSlideDiv0Div1Div0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: TeamSectionSlidesItem) => Partial<ComponentProps<"h3">>);
    swiperSlideDiv0Div1Div0H30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TeamSectionSlidesItem) => Partial<ComponentProps<typeof SmartLink>>);
    swiperSlideDiv0Div1Div1H40H4Props?: Partial<ComponentProps<"h4">> | ((item: TeamSectionSlidesItem) => Partial<ComponentProps<"h4">>);
    teamSectionSlides: TeamSectionSlidesItem[];
    teamSectionSlidesItemWrapper?: (item: TeamSectionSlidesItem, content: ReactNode) => ReactNode;
    teamSectionSlidesRenderer?: (defaultNode: ReactNode) => ReactNode;
    teamSectionSlidesLinkVisible?: boolean;
    teamSectionSlidesLinkRenderer?: (item: TeamSectionSlidesItem, defaultNode: ReactNode) => ReactNode;
    teamSectionSlidesImageVisible?: boolean;
    teamSectionSlidesImageRenderer?: (item: TeamSectionSlidesItem, defaultNode: ReactNode) => ReactNode;
    teamSectionSlidesH3Visible?: boolean;
    teamSectionSlidesH3Renderer?: (item: TeamSectionSlidesItem, defaultNode: ReactNode) => ReactNode;
    teamSectionSlidesH4Visible?: boolean;
    teamSectionSlidesH4Renderer?: (item: TeamSectionSlidesItem, defaultNode: ReactNode) => ReactNode;
    teamSectionSlidesLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TeamSectionSlidesItem) => Partial<ComponentProps<typeof SmartLink>>);
    teamSectionSlidesImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TeamSectionSlidesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    teamSectionSlidesH3Props?: Partial<ComponentProps<"h3">> | ((item: TeamSectionSlidesItem) => Partial<ComponentProps<"h3">>);
    teamSectionSlidesH4Props?: Partial<ComponentProps<"h4">> | ((item: TeamSectionSlidesItem) => Partial<ComponentProps<"h4">>);
    teamSectionSlidesSwiperSlideProps?: Partial<ComponentProps<typeof SwiperSlide>> | ((item: TeamSectionSlidesItem) => Partial<ComponentProps<typeof SwiperSlide>>);
    teamSectionIconsItemWrapper?: (item: TeamSectionIconsItem, content: ReactNode) => ReactNode;
    teamSectionIconsRenderer?: (defaultNode: ReactNode) => ReactNode;
    teamSectionIconsLinkVisible?: boolean;
    teamSectionIconsLinkRenderer?: (item: TeamSectionIconsItem, defaultNode: ReactNode) => ReactNode;
    teamSectionIconsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TeamSectionIconsItem) => Partial<ComponentProps<typeof SmartLink>>);
    teamSectionBadgesItemWrapper?: (item: TeamSectionBadgesItem, content: ReactNode) => ReactNode;
    teamSectionBadgesRenderer?: (defaultNode: ReactNode) => ReactNode;
    teamSectionBadgesLinkVisible?: boolean;
    teamSectionBadgesLinkRenderer?: (item: TeamSectionBadgesItem, defaultNode: ReactNode) => ReactNode;
    teamSectionBadgesLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TeamSectionBadgesItem) => Partial<ComponentProps<typeof SmartLink>>);
};

const HomeSixteenTeamSectionGenerated: FC<HomeSixteenTeamSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Meet Our Team",
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "Certified experts dedicated to your health",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0SpanText = "transformation journey",
    sectionImageWithBasePath0ImageAlt = "teams",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/teams-img-1.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    linkLinkProps,
    teamSectionBadgesLinkLinkProps,
    sectionSwiper0SwiperProps,
    swiperSlideDiv0Div0ImageWithBasePath0ImageProps,
    swiperSlideDiv0Div1Div0H30H3Props,
    swiperSlideDiv0Div1Div0H30Link0LinkProps,
    swiperSlideDiv0Div1Div1H40H4Props,
    swiperSlideSwiperSlideProps,
    teamSectionSlides,
    teamSectionSlidesItemWrapper,
    teamSectionSlidesRenderer,
    teamSectionSlidesLinkVisible,
    teamSectionSlidesLinkRenderer,
    teamSectionSlidesImageVisible,
    teamSectionSlidesImageRenderer,
    teamSectionSlidesH3Visible,
    teamSectionSlidesH3Renderer,
    teamSectionSlidesH4Visible,
    teamSectionSlidesH4Renderer,
    teamSectionSlidesLinkProps,
    teamSectionSlidesImageProps,
    teamSectionSlidesH3Props,
    teamSectionSlidesH4Props,
    teamSectionSlidesSwiperSlideProps,
    teamSectionIconsItemWrapper,
    teamSectionIconsRenderer,
    teamSectionIconsLinkVisible,
    teamSectionIconsLinkRenderer,
    teamSectionIconsLinkProps,
    teamSectionBadgesItemWrapper,
    teamSectionBadgesRenderer,
    teamSectionBadgesLinkVisible,
    teamSectionBadgesLinkRenderer,
    teamSectionBadgesLinkProps,
}) => {
    return (
        <section className="section team-section-sixteen">
            <div className="container">
                <div className="section-header-sixteen wow fadeInDown" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    <div className="sub-title">{sectionDiv0Div0Div0DivText}</div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {sectionDiv0Div0H20H2Text}
                            <br />
                            {" "}
                            <span>{sectionDiv0Div0H20Span0SpanText}</span>
                        </h2>
                    ))}
                </div>
            </div>
            <Swiper modules={[Autoplay]} loop={true} speed={2500} autoplay={{ delay: 2500, disableOnInteraction: false }} slidesPerView={4} spaceBetween={24} breakpoints={{
                1400: { slidesPerView: 4 },
                1200: { slidesPerView: 3 },
                992: { slidesPerView: 3 },
                768: { slidesPerView: 2 },
                576: { slidesPerView: 1 },
                0: { slidesPerView: 1 }
            }} className="team-slider-sixteen" {...(sectionSwiper0SwiperProps ?? {})}>
                {renderCollectionNode(
                    teamSectionSlides,
                    (item: TeamSectionSlidesItem) => (
                        <SwiperSlide className={item.className ?? "slide-item"} {...(typeof teamSectionSlidesSwiperSlideProps === "function" ? teamSectionSlidesSwiperSlideProps(item) : (teamSectionSlidesSwiperSlideProps ?? {}))} {...(typeof swiperSlideSwiperSlideProps === "function" ? swiperSlideSwiperSlideProps(item) : (swiperSlideSwiperSlideProps ?? {}))} key={item.key}>
                            <div className={item.div0ClassName ?? "team-item-sixteen wow fadeInUp"} data-wow-duration={item.dataWowDuration}>
                                <div className={item.div0ClassName2 ?? "team-overlay"}>
                                    <span className={item.span0ClassName ?? "experience"}>{item.span0Text}</span>
                                    <div className="social-icon">
                                        {renderCollectionNode(
                                            item.socialIconItems ?? [],
                                            (item: TeamSectionIconsItem) => (
                                                renderItemNode(teamSectionIconsLinkVisible, teamSectionIconsLinkRenderer, item, (
                                                    <SmartLink href={item.href ?? "#"} className={item.linkClassName ?? "icon"} aria-label={item.ariaLabel} {...(typeof teamSectionIconsLinkProps === "function" ? teamSectionIconsLinkProps(item) : (teamSectionIconsLinkProps ?? {}))} {...(typeof linkLinkProps === "function" ? linkLinkProps(item) : (linkLinkProps ?? {}))} key={item.key}>
                                                        <i className={item.className} />
                                                    </SmartLink>
                                                ))
                                            ),
                                            teamSectionIconsItemWrapper,
                                            teamSectionIconsRenderer
                                        )}
                                    </div>
                                    {renderItemNode(teamSectionSlidesImageVisible, teamSectionSlidesImageRenderer, item, (
                                        <SmartImage src={item.src} alt={item.alt ?? "team"} className={item.imageWithBasePath0ClassName ?? "img-fluid img-one"} {...(typeof teamSectionSlidesImageProps === "function" ? teamSectionSlidesImageProps(item) : (teamSectionSlidesImageProps ?? {}))} {...(typeof swiperSlideDiv0Div0ImageWithBasePath0ImageProps === "function" ? swiperSlideDiv0Div0ImageWithBasePath0ImageProps(item) : (swiperSlideDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                    ))}
                                </div>
                                <div className={item.div1ClassName ?? "team-content"}>
                                    <div className={item.div0ClassName3 ?? "team-info"}>
                                        {renderItemNode(teamSectionSlidesH3Visible, teamSectionSlidesH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "team-name"} {...(typeof teamSectionSlidesH3Props === "function" ? teamSectionSlidesH3Props(item) : (teamSectionSlidesH3Props ?? {}))} {...(typeof swiperSlideDiv0Div1Div0H30H3Props === "function" ? swiperSlideDiv0Div1Div0H30H3Props(item) : (swiperSlideDiv0Div1Div0H30H3Props ?? {}))}>
                                                {renderItemNode(teamSectionSlidesLinkVisible, teamSectionSlidesLinkRenderer, item, (
                                                    <SmartLink href={item.href ?? "#"} {...(typeof teamSectionSlidesLinkProps === "function" ? teamSectionSlidesLinkProps(item) : (teamSectionSlidesLinkProps ?? {}))} {...(typeof swiperSlideDiv0Div1Div0H30Link0LinkProps === "function" ? swiperSlideDiv0Div1Div0H30Link0LinkProps(item) : (swiperSlideDiv0Div1Div0H30Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                ))}
                                            </h3>
                                        ))}
                                        <p>{item.p0Text}</p>
                                    </div>
                                    <div className={item.div1ClassName2 ?? "team-special"}>
                                        {renderItemNode(teamSectionSlidesH4Visible, teamSectionSlidesH4Renderer, item, (
                                            <h4 className={item.h40ClassName ?? "specialties-title"} {...(typeof teamSectionSlidesH4Props === "function" ? teamSectionSlidesH4Props(item) : (teamSectionSlidesH4Props ?? {}))} {...(typeof swiperSlideDiv0Div1Div1H40H4Props === "function" ? swiperSlideDiv0Div1Div1H40H4Props(item) : (swiperSlideDiv0Div1Div1H40H4Props ?? {}))}>{item.h40Text ?? "Specialties:"}</h4>
                                        ))}
                                        <div className="specialties-list">
                                            {renderCollectionNode(
                                                item.specialtiesListItems ?? [],
                                                (item: TeamSectionBadgesItem) => (
                                                    renderItemNode(teamSectionBadgesLinkVisible, teamSectionBadgesLinkRenderer, item, (
                                                        <SmartLink href={item.href ?? "#"} className={item.className ?? "badge"} {...(typeof teamSectionBadgesLinkProps === "function" ? teamSectionBadgesLinkProps(item) : (teamSectionBadgesLinkProps ?? {}))} {...(typeof teamSectionBadgesLinkLinkProps === "function" ? teamSectionBadgesLinkLinkProps(item) : (teamSectionBadgesLinkLinkProps ?? {}))} key={item.key}>{item.linkText}</SmartLink>
                                                    ))
                                                ),
                                                teamSectionBadgesItemWrapper,
                                                teamSectionBadgesRenderer
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                    ),
                    teamSectionSlidesItemWrapper,
                    teamSectionSlidesRenderer
                )}
            </Swiper>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid element-one" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeSixteenTeamSectionGenerated;
